<app-report reportId="alignmentReport" screen="ALGSD" [submenu]="true"></app-report>
